import React from 'react';
import { EventedModal, ModalNames } from '|/app/modals';
import { StepElement } from '|/app/purchase/flow/steps-router';
import { Step } from '|/app/services';
import { NextStepNavigationContextProvider, PageEventContextProvider } from '|/context';
import { AppFrameworkContextProvider } from '|/helpers/app-framework';
import styles from './verification-task-sheet.module.css';
import { getPageEventContext } from '../constants/page-event-mappings';

interface VerificationTaskSheetProps {
  step: Step;
  onSubmit: () => void;
  onClose: () => void;
}

const VerificationTaskSheet: React.FC<VerificationTaskSheetProps> = ({
  step,
  onSubmit,
  onClose
}) => {
  // Mounted only while a task is open (verifications-panel gates on openTaskStepId), so isOpen is
  // constant. Goes through EventedModal rather than the raw DS hook so the sheet joins the managed
  // back-close set — it wraps the verifx MFE, whose own modals stack on top of it.
  return (
    <EventedModal
      isOpen
      analyticsId={ModalNames.VerificationTaskSheet}
      modalHeader={step.name}
      onClose={onClose}
      disableOutsideClose
      disableEscapeClose
      contentPadding={false}
      zIndex={700}
      classes={{ body: styles.modalBody }}
    >
      <PageEventContextProvider value={getPageEventContext(step.id)}>
        <NextStepNavigationContextProvider
          value={{ handleNextStep: onSubmit, ensureInProgress: () => Promise.resolve() }}
        >
          <AppFrameworkContextProvider>
            <StepElement
              step={step}
              isHidden={false}
              GetDashboardAndRouteToNextStep={() => {
                onSubmit();
              }}
            />
          </AppFrameworkContextProvider>
        </NextStepNavigationContextProvider>
      </PageEventContextProvider>
    </EventedModal>
  );
};

export default VerificationTaskSheet;
